import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const RectanglePyramidIllustration = ({
  width = 347,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 347 224">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path
                fill="#ED585D"
                d="M218.274 223.998H5.597c-3.078 0-5.597-2.52-5.597-5.6v-56c0-3.085 2.519-5.6 5.597-5.6h212.677c3.078 0 5.597 2.515 5.597 5.6v56c0 3.08-2.519 5.6-5.597 5.6"
                transform="translate(-947 -2139) translate(201 2079) translate(746 60)"
              />
              <path
                fill="#000"
                fillOpacity=".1"
                d="M218.406 223.998H173.5v-67.2h44.906c3.006 0 5.465 2.515 5.465 5.6v56c0 3.08-2.46 5.6-5.465 5.6"
                transform="translate(-947 -2139) translate(201 2079) translate(746 60)"
              />
              <path
                fill="#004C90"
                d="M279.839 145.598H67.16c-3.078 0-5.596-2.514-5.596-5.6v-56c0-3.08 2.518-5.6 5.596-5.6H279.84c3.078 0 5.596 2.52 5.596 5.6v56c0 3.086-2.518 5.6-5.596 5.6"
                transform="translate(-947 -2139) translate(201 2079) translate(746 60)"
              />
              <path
                fill="#000"
                fillOpacity=".1"
                d="M279.839 145.598H173.5v-67.2h106.339c3.078 0 5.596 2.52 5.596 5.6v56c0 3.086-2.518 5.6-5.596 5.6"
                transform="translate(-947 -2139) translate(201 2079) translate(746 60)"
              />
              <path
                fill="#FF7236"
                d="M341.403 223.998H240.661c-3.078 0-5.596-2.52-5.596-5.6v-56c0-3.085 2.518-5.6 5.596-5.6h100.742c3.084 0 5.597 2.515 5.597 5.6v56c0 3.08-2.513 5.6-5.597 5.6"
                transform="translate(-947 -2139) translate(201 2079) translate(746 60)"
              />
              <path
                fill="#000"
                fillOpacity=".1"
                d="M341.403 223.998H240.661c-3.078 0-5.596-2.52-5.596-5.6v-56c0-3.085 2.518-5.6 5.596-5.6h100.742c3.084 0 5.597 2.515 5.597 5.6v56c0 3.08-2.513 5.6-5.597 5.6"
                transform="translate(-947 -2139) translate(201 2079) translate(746 60)"
              />
              <path
                fill="#6AB3A9"
                d="M223.871 67.2H123.129c-3.078 0-5.597-2.52-5.597-5.6v-56c0-3.086 2.519-5.6 5.597-5.6h100.742c3.078 0 5.597 2.514 5.597 5.6v56c0 3.08-2.519 5.6-5.597 5.6"
                transform="translate(-947 -2139) translate(201 2079) translate(746 60)"
              />
              <path
                fill="#1D1D1B"
                fillOpacity=".1"
                d="M223.871 67.2H173.5V0h50.371c3.078 0 5.597 2.514 5.597 5.6v56c0 3.08-2.519 5.6-5.597 5.6"
                transform="translate(-947 -2139) translate(201 2079) translate(746 60)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </DefaultIconWrapper>
);
